import JSZip from 'jszip' ;

const jszip = () => {
  window.JSZip = window.JSZip || JSZip;
};

export default jszip;